import { Box, Divider } from '@mui/material';
import * as React from 'react';

import { BoxDetailsItem } from '../../../components';
import { IChangeBucketItemPayload } from '../../../types/bucket';
import { ICampaignItem } from '../../../types/campaigns';
import { IOnDemandItem } from '../../../types/inventories';
import { IReportEngagementItem } from '../../../types/reports';
import { BoxDetailsSidebarModeEnum } from '../../../types/shell';
import { getCanRemoveItemFromCampaign, getIsItemLastVisibleInCampaign } from '../../../utils/campaigns';

interface IProps {
  mode?: BoxDetailsSidebarModeEnum;
  items?: (ICampaignItem | IOnDemandItem | IReportEngagementItem)[] | null | undefined;
  onChange?: (itemData: IChangeBucketItemPayload) => void;
  onRemove?: (item: ICampaignItem | IOnDemandItem) => void;
  children?: React.ReactElement | React.ReactElement[];
  canRemoveAll?: boolean;
  isDirectSend?: boolean;
}

const SendItemsForm = ({ items, onChange, onRemove, mode, canRemoveAll = true, isDirectSend, children }: IProps) => {
  return (
    <Box sx={{ overflowY: 'auto', px: 3, height: '100%' }}>
      <Divider />
      {items?.map((item) => {
        const isLastVisibleItem = getIsItemLastVisibleInCampaign(items, item.item_id);
        const isCustomizableItem = item.item_customization_allowed;
        const canRemoveItem = canRemoveAll
          ? getCanRemoveItemFromCampaign(items, item.item_id)
          : items?.length > 1 && getCanRemoveItemFromCampaign(items, item.item_id);

        return (
          <BoxDetailsItem
            item={item}
            canHide={!isLastVisibleItem && !isCustomizableItem}
            key={item.item_id}
            mode={mode}
            onChange={onChange}
            onRemove={canRemoveItem ? onRemove : undefined}
            isDirectSend={isDirectSend}
          />
        );
      })}
      {children}
    </Box>
  );
};

export default SendItemsForm;
